import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {AvlSpeedGmapComponentDefinition} from './avl-speed-gmap.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as moment from 'moment';
import * as GoogleMapsLoader from '../../../../formbird-mapping/src/lib/google/GoogleMapsLoader.js';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data'; // test test

@Component({
  templateUrl: './avl-speed-gmap.component.html',
  styleUrls: [
    './avl-speed-gmap.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlSpeedGmapComponent extends AbstractComponent<AvlSpeedGmapComponentDefinition> implements OnInit, AfterViewInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('content', {static: false}) content: ElementRef;
  @ViewChild('containerChart', {static: false}) containerChart: ElementRef;
  @ViewChild('tooltipInfo', {static: false}) tooltipInfo: ElementRef;

  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  google;
  map;
  tooltipConfig;
  vehicleMainImageFileField;
  markers = [];
  polyLines = [];
  isFirstTime = true;
  vehicles;
  previousPopup;
  minZoom;
  geozonesQuery = '';
  geozonesData = '';
  geozonesName = '';
  mapVehicles = {};
  apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // combine
  autocompleteURL = 'https://www.geocode.farm/v3/json/forward/?addr='; // combine
  defaultZoom;
  timeFormat;
  displayArrorHeads;
  maxPoints;
  firstTime;
  startDate;
  endDate;
  chooseDate;
  isfirstTimeupdateEnddate = false; // angularJS, init value = true
  isfirstTimeupdateStartdate = false; // angularJS, init value = true
  isfirstTimeupdateMaxSpeed = false; // angularJS, init value = true
  isfirstTimeupdateMinSpeed = false; // angularJS, init value = true
  isInit = true;
  proccessEventTime = 0;
  proccessVehicleTime = 0;
  minSpeed;
  maxSpeed;

  constructor(
    protected cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.minZoom === 'undefined' || this.componentDefinition.minZoom === null)) {
      this.minZoom = this.componentDefinition.minZoom;
    }
    if (!(typeof this.componentDefinition.defaultZoom === 'undefined' || this.componentDefinition.defaultZoom === null)) {
      this.defaultZoom = this.componentDefinition.defaultZoom;
    }
    if (!(typeof this.componentDefinition.tooltipsTable === 'undefined' || this.componentDefinition.tooltipsTable === null)) {
      this.tooltipConfig = this.componentDefinition.tooltipsTable;
    }
    if (!(typeof this.componentDefinition.image === 'undefined' || this.componentDefinition.image === null)) {
      this.vehicleMainImageFileField = this.componentDefinition.image;
    }
    if (!(typeof this.componentDefinition.geozones === 'undefined' || this.componentDefinition.geozones === null)) {
      if (this.componentDefinition.geozones.filter) {
        this.geozonesQuery = this.componentDefinition.geozones.filter;
      }
      if (this.componentDefinition.geozones.data) {
        this.geozonesData = this.componentDefinition.geozones.data;
      }
      if (this.componentDefinition.geozones.name) {
        this.geozonesName = this.componentDefinition.geozones.name;
      }
    }
    if (!(typeof this.componentDefinition.displayArrorHeads === 'undefined' || this.componentDefinition.displayArrorHeads === null)) {
      this.displayArrorHeads = this.componentDefinition.displayArrorHeads;
    }
    if (!(typeof this.componentDefinition.maxPoints === 'undefined' || this.componentDefinition.maxPoints === null)) {
      this.maxPoints = this.componentDefinition.maxPoints;
    }

    this.vehicles = this.document[this.componentDefinition.avlVehiclesField];

    const clientConfig = this.configService.clientConfig();
    if (clientConfig) {
      if (clientConfig.googleMapsKey) {
        this.apiKey = clientConfig.googleMapsKey;
      }
      if (clientConfig.dateFormat && clientConfig.dateFormat.time) {
        this.timeFormat = clientConfig.dateFormat.time;
      }
    }

    this.minSpeed = 0;
    this.maxSpeed = 0;

    this.firstTime = true;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    const strStart = 'dateTimeStart';
    this.document[strStart] = this.startDate;
    const strEnd = 'dateTimeEnd';
    this.document[strEnd] = new Date();

    // watcher
    const dateTimeFieldStartSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeFieldStart
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeFieldStart, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeFieldStart] = fieldValue;
        this.watchDateTimeFieldStart(fieldValue);
    });
    const dateTimeFieldEndSub = this.changedDocumentService.watch(this.componentDefinition.dateTimeFieldEnd
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch dateTimeFieldEnd, value = ' + fieldValue);
        this.document[this.componentDefinition.dateTimeFieldEnd] = fieldValue;
        this.watchDateTimeFieldEnd(fieldValue);
    });
    const maxSpeedSub = this.changedDocumentService.watch(this.componentDefinition.maxSpeed
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch maxSpeed, value = ' + fieldValue);
        this.document[this.componentDefinition.maxSpeed] = fieldValue;
        this.watchMaxSpeedDoc(fieldValue);
    });
    const minSpeedSub = this.changedDocumentService.watch(this.componentDefinition.minSpeed
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch minSpeed, value = ' + fieldValue);
        this.document[this.componentDefinition.minSpeed] = fieldValue;
        this.watchMinSpeedDoc(fieldValue);
    });
    const avlVehiclesFieldSub = this.changedDocumentService.watch(this.componentDefinition.avlVehiclesField
      , this.document.documentId).subscribe(fieldValue => {
        console.log('watch avlVehiclesField, value = ' + fieldValue);
        this.document[this.componentDefinition.avlVehiclesField] = fieldValue;
        this.watchAvlVehiclesField(fieldValue);
    });
    this.subs.add(avlVehiclesFieldSub);
    this.subs.add(dateTimeFieldStartSub);
    this.subs.add(dateTimeFieldEndSub);
    this.subs.add(maxSpeedSub);
    this.subs.add(minSpeedSub);

    //

    this.loadMap(() => {
      console.log('GoogleMapsLoader loaded');

      if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
        this.target.nativeElement.style.height = '180 px';
      } else {
        let height = 180 * this.componentDefinition.heightNum;
        const docHeight = document.body.scrollHeight;
        if (height > (docHeight - 180)) {
          height = docHeight - 180;
        }
        this.target.nativeElement.style.height = '' + height + 'px';
      }
      const MapLabel = this.sclUtilGmapService.initMapLabel(this.google);

      const uluru = {lat: -34.735613, lng: 138.584043};
      this.map = new this.google.maps.Map(this.target.nativeElement, {zoom: 4, center: uluru});
      this.map.addListener('dragend', this.changeData.bind(this));
      this.map.addListener('zoom_changed', this.changeData.bind(this));
      this.map.addListener('click', () => {
        if (this.previousPopup) {
          this.previousPopup.close();
        }
      });

      if (this.geozonesQuery && this.geozonesData) {
        // var options = scope.sclUtilMap.constructQueryVehicleData(imeis, scope.doc);
        const options = this.sclUtilMapService.constructQueryGeoZones(this.geozonesQuery, this.document);   // testing
        // getGeoZones
        this.searchService.search(options).then((data) => {
          console.log('getGeoZones result = ', data);
          this.sclUtilGmapService.getGeoCoors(SearchResultsProcessor, data, this.geozonesData, this.geozonesName, this.google
            , (geozones) => {
              for (let i = 0 ; i < geozones.length; i++) {
                const geozone = geozones[i];
                if (geozone.shape === 'Point') {
                  const mapLabel: any = new MapLabel({
                          text: geozone.name,
                          position: geozone.coors[0],
                          map: this.map,
                          fontSize: 20
                    });
                  const marker = new this.google.maps.Marker({
                    position: geozone.coors[0]
                  });
                  marker.setMap(this.map);
                } else if (geozone.shape === 'Line') {
                  if (this.geozonesName) {
                    const textCoor = this.centerOfZone(geozone.coors);
                    const mapLabel = new MapLabel({
                        text: geozone.name,
                        position: textCoor,
                        map: this.map,
                        fontSize: 20
                    });
                  }
                  const polyline = new this.google.maps.Polyline({
                    path: geozone.coors,
                    editable: false,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                  });
                  polyline.setMap(this.map);
                } else if (geozone.shape === 'Polygon') {
                  if (this.geozonesName) {
                    const textCoor = this.centerOfZone(geozone.coors);
                    const mapLabel = new MapLabel({
                      text: geozone.name,
                      position: textCoor,
                      map: this.map,
                      fontSize: 20
                    });
                  }
                  const polyline = new this.google.maps.Polygon({
                    path: geozone.coors,
                    editable: false,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                  });
                  polyline.setMap(this.map);
                } else {
                  console.log('not handles yet!!!');
                }
              }
            });
        });
      }

      this.changeData();
    }); // end loadMap

  }


  ngAfterViewInit() {

  }

  loadMap(cb) {
    // this.apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
    this.apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000
    GoogleMapsLoader.KEY = this.apiKey;
    GoogleMapsLoader.LIBRARIES = 'places';
    // GoogleMapsLoader.SENSOR = true;
    GoogleMapsLoader.load((google) => {
      this.google = google;
      cb();
    });
  }

  getPointFeature(location , image) {
    const marker = new this.google.maps.Marker({
      icon: image,
      position: location
    });

    return marker;
  }

  clearMap() {
    for (const id in this.markers) {
      if (this.markers.hasOwnProperty(id)) {
        this.markers[id].setMap(null);
      }
    }

    this.markers = [];

    for (const id in this.polyLines) {
      if (this.polyLines.hasOwnProperty(id)) {
        this.polyLines[id].setMap(null);
      }
    }

    this.polyLines = [];
  }

  centerOfZone(coordinates) {
    let lat = 0;
    let lng = 0;
    if (coordinates.length <= 0) {
      return;
    }
    for (let i = 0; i < coordinates.length; i++) {
      lat = lat + coordinates[i].lat();
      lng = lng + coordinates[i].lng();
    }
    return new this.google.maps.LatLng(lat / coordinates.length, lng / coordinates.length);
  }
  getDateInfo(date) {

    let startDate = new Date(this.startDate ? this.startDate : null);
    startDate = new Date(startDate.getTime());
    console.log('Offset Time: ' + startDate.getTimezoneOffset()
     + '\tstartDate.getTime(): ' + startDate.getTime() + '\tTestDate: ' + startDate);

    let endDate = new Date(this.endDate ? this.endDate : null);
    endDate = new Date(endDate.getTime());

    const startDateFormat = startDate.toISOString();
    const endDateFormat = endDate.toISOString();

    const args = [];
    args.push(startDateFormat);
    args.push(endDateFormat);

    return args;
  }
  // this function hasn't executed
  // queryLastEvent() {
  //   const res = this.iMEIFilter.replace(/'/g, '"');
  //   const filterObj = JSON.parse(res);

  //   const filter = {
  //       query: filterObj.query,
  //       sort: [
  //         {
  //           'features.properties.eventDate': 'desc'
  //         }
  //       ],
  //       size: 1
  //   };
  //   const query = JSON.stringify(filter);
  //   console.log('Query get last event is ' + query);

  //   return query;
  // }
  updateLocation() {
    console.log('Choosing date ..................');
    this.clearMap();
    this.chooseDate = true;
    this.fieldValue = this.document[this.fieldName];
    // ctrl.$setPristine(true);
  }

  proccessData(data) {
    const customData = data;
    const vehicles = [];
    if (customData && customData.length > 0) {
      console.log('customData[0]: ');
      console.log(customData[0]);
      if (this.maxPoints) {
          if (customData.length > this.maxPoints) {
            console.log('Too much data: ' + customData.length);
            this.notificationService.printMessage('Too much data selected: ' + customData.length + ', please zoom in closer');
            return;
          }
      }
      this.clearMap();
      this.proccessEventTime++;
      const mapTempVehicles = {};
      for (let i = 0; i < customData.length; i++) {
        const valJson = customData[i];
        const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');


        if (vehicleRel && vehicleRel.documentId) {
          if (! mapTempVehicles[vehicleRel.documentId]) {
            mapTempVehicles[vehicleRel.documentId] = {};
          }
        }
      }

      const vehicleIDs = [];


      for (const id in mapTempVehicles) {
        if (!this.mapVehicles[id]) {
          vehicleIDs.push(id);
        }
      }

      if (vehicleIDs.length > 0) {
        const options = this.sclUtilMapService.constructQueryDocument(vehicleIDs, this.document);
        // getVehicleData
        this.searchService.search(options).then( (results: any) => {
          // results = AvlTestData.vehicleData; // test test
          if (results && results.data && results.data.hits && results.data.hits.hits && results.data.hits.hits.length > 0) {
            const result = results.data.hits.hits;
            for (let i = 0; i < result.length; i++) {
              const docID = result[i]._source.documentId;
              this.mapVehicles[docID] = result[i];
            }

            this.processVehicleData(mapTempVehicles, customData);
          } else {
            console.error('Something wrong, can not get vehicle info with filter: ', options.filter);
          }
          }, (err) => {
            console.error('error options when getting vehicles data :' + options.filter);
            console.error(err);
          }
        );
      } else {
        this.processVehicleData(mapTempVehicles, customData);
      }

    } else {
      this.notificationService.printMessage('No data');
      this.clearMap();
    }
  }
  processVehicleData(mapTempVehicles, customData) {
    console.log('proccess vehicle data ' + this.proccessVehicleTime + '/' + this.proccessEventTime);
    if (this.proccessVehicleTime < this.proccessEventTime - 1) {
      this.proccessVehicleTime = this.proccessEventTime;
      return;
    }
    this.proccessVehicleTime = this.proccessEventTime;
    // vehicle data
    for (const id in mapTempVehicles) {
      if (mapTempVehicles.hasOwnProperty(id)) {
        mapTempVehicles[id].data = this.mapVehicles[id];
      }
    }
    // vehicle's event
    for (let j = 0; j < customData.length; j++) {
      const valJson = customData[j];
      const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');
      if (vehicleRel) {
        const eventId = vehicleRel.documentId;
        if (!mapTempVehicles[eventId].events) {
          mapTempVehicles[eventId].events = [];
        }
        mapTempVehicles[eventId].events.push(valJson);
      }
    }
    for (const id in mapTempVehicles) {
      if (mapTempVehicles.hasOwnProperty(id)) {
        const vehicle = mapTempVehicles[id];
        const listEvent = mapTempVehicles[id].events;
        if (listEvent.length >= 1) {
            vehicle.startDate = listEvent[0].eventDate;
            vehicle.endDate = listEvent[listEvent.length - 1].eventDate;
        }

        this.loadDataForDevice(vehicle.data, vehicle.events, false);
      }
    }
  }
  loadDataForDevice(vehicle, data, isFit) {
    console.log(' loadDataForDevice ');
    const results = [];
    if (this.isFirstTime && this.vehicles && this.vehicles.length > 0 ) {
      // first time load map, just center map to last event
      console.log('data.length=' + data.length);
      if ( data.length > 0) {
        this.isFirstTime = false;
        console.log('center map, request location events');
        const res: any = this.sclUtilMapService.parseAVLData_New(data[0]);
        const center =  new this.google.maps.LatLng ( res.latitude, res.longitude);
        // center map, auto trigger changeData
        this.map.setCenter( center );
        this.map.setZoom(12);
        // request events around
        // changeData();
      }
    } else {
      for (let j = 0; j < data.length; j++) {
        const valJson = data[j];

        const icon = this.sclUtilMapService.checkAVLSpeed(SclMapConstantService.AVL_SPEED_BEGINNING,
            parseFloat(valJson.speedKPH).toFixed(5),
            parseFloat(valJson.heading), 5, 20, 50, 100, 150);
        const res = this.sclUtilMapService.parseAVLData_New(valJson);
        res.imeiDocumentsRel = data[j].imeiDocumentsRel;
        res.icon = icon;
        results.push(res);
      }
      this.showMap(vehicle, results);
    }
  }
  changeData() {
    if (this.map == null) {
      return;
    }
    if (!this.vehicles || this.vehicles.length <= 0) {
      if (this.map.getZoom() < this.minZoom) {
        this.notificationService.printMessage('Please zoom map closer');
      } else {
        const dates = this.getDateInfo(new Date(this.endDate));
        const bounds = this.map.getBounds();
        if (bounds == null) {
          console.log('boundary is null');
          return;
        }
        const top = bounds.getNorthEast().lat();
        const right = bounds.getNorthEast().lng();

        const bot = bounds.getSouthWest().lat();
        const left = bounds.getSouthWest().lng();
        const bottomLeft = [left, bot];
        const topRight = [right, top];

        const params = {
          functionName: 'getAvlAllEventInRange',
          componentDocumentName: 'sc-avl-speed',
          functionParameters: [this.componentDefinition.dataService, dates[0], dates[1], this.minSpeed, this.maxSpeed, bottomLeft, topRight]
        };

        // apiGetAvlAllEventInRange
        this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
          console.log('%c getAvlAllEventInRange 1', 'color:blue');
          this.proccessData(customData.data);
        }, (err) => {
          console.error('error query current location :');
          console.error(err);
        });
      }
    } else {
      this.chooseDate = true;
      this.fieldValue = this.document[this.fieldName];

      if (this.isFirstTime) {
        console.log('get last event');
        const params = {
          functionName: 'getAvlEvent',
          componentDocumentName: 'sc-avl-speed',
          functionParameters: [this.componentDefinition.dataService, this.vehicles[0].documentId]
        };
        // apiGetAvlEvent
        this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
          console.log('%c getAvlEvent', 'color:blue');
          // customData = AvlTestData.getAvlEvent; // test test
          this.proccessData(customData.data);
        }, (err) => {
          console.error('error query current location :');
          console.error(err);
        });
      } else {
        console.log('request all event');
        const dates = this.getDateInfo(new Date(this.endDate));
        const bounds = this.map.getBounds();
        if (bounds == null) {
          console.log('boundary is null');
          return;
        }

        const top = bounds.getNorthEast().lat();
        const right = bounds.getNorthEast().lng();

        const bot = bounds.getSouthWest().lat();
        const left = bounds.getSouthWest().lng();
        const bottomLeft = [left, bot];
        const topRight = [right, top];

        // apiGetAvlEventInRange
        const params = {
          functionName: 'getAvlEventInRange',
          componentDocumentName: 'sc-avl-speed',
          functionParameters: [this.componentDefinition.dataService, this.vehicles[0].documentId
          , dates[0], dates[1], this.minSpeed, this.maxSpeed, bottomLeft, topRight]
        };
        this.httpClient.post('api/execute', params).subscribe( (customData: any) => {
          console.log('%c getAvlEventInRange 2, this.minSpeed = ' + this.minSpeed + ', this.maxSpeed = ' + this.maxSpeed, 'color:blue');
          // // test test begin
          // const testData = AvlTestData.getAvlAllEventInRange2;
          // if ( this.document[this.componentDefinition.minSpeed] > 0 && this.document[this.componentDefinition.maxSpeed] > 0 ) {
          //   const minSpeed = this.document[this.componentDefinition.minSpeed];
          //   const maxSpeed = this.document[this.componentDefinition.maxSpeed];
          //   const lst = [];
          //   for (let i = 0; i < testData.data.length; i++) {
          //     if (testData.data[i].speedKPH >= minSpeed && testData.data[i].speedKPH <= maxSpeed) {
          //       lst.push(testData.data[i]);
          //     }
          //   }
          //   testData.data = lst;
          // }
          // customData =  testData;
          // // test test end
          this.proccessData(customData.data);
        });

      }
    }
  }

  showMap(vehicle, data) {
    const vehicleData = vehicle._source;

    if (data.length === 0) {
        return;
    }
    const self = this;
    const listCoordinate = [];
    for (let i = 0; i < data.length - 1; i++) {

        const coordinate = new this.google.maps.LatLng(data[i].latitude, data[i].longitude);
        listCoordinate.push(coordinate);

        const arrow = new this.google.maps.Marker({
            map: this.map,
            icon: data[i].icon,
            position: coordinate
        });
        arrow.data = data[i];

        arrow.addListener('mouseover', showPopup);
        arrow.addListener('click', showPopup);

        function showPopup() {
          if (self.previousPopup) {
            self.previousPopup.close();
          }

          let name = '';
          let url = '';
          let deviceName = '';
          const relatedvehicleData: any = self.sclUtilAvlService.getRelatedDocument(this.data, 'vehicle');
          if (relatedvehicleData) {
              url = 'form/' + relatedvehicleData.documentId;
              deviceName = relatedvehicleData.name;
          }
          name += '<a href=' + url + '><b>' + deviceName + '</b></a><br>';

          let tooltipImg = '/api/getFile/562b8d70-5eb0-11e8-9d98-e5cdc65a95c1/garbage-truck.jpg';
          let imgtooltip = '';

          if (self.vehicleMainImageFileField && vehicleData[self.vehicleMainImageFileField]
              && Array.isArray(vehicleData[self.vehicleMainImageFileField])
              && vehicleData[self.vehicleMainImageFileField].length > 0) {

              const imageData = vehicleData[self.vehicleMainImageFileField][0];
              tooltipImg = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
              imgtooltip = '<img src=' + tooltipImg + '/>';
          }




          const width = self.target.nativeElement.offsetWidth / 10 * 6;

          const emei = self.toDataRow('IMEI', this.data.imei);
          const addressRow = self.toDataRow('Address', '');
          const gps = self.toDataRow('GPS', this.data.latitude.toString() + ', ' + this.data.longitude.toString());
          const time = self.toDataRow('Time', self.formatDateTime( this.data.eventDate));
          const speed = self.toDataRow('Speed', this.data.speedKPH);
          const heading = self.toDataRow('Heading', this.data.heading);
          const imageRow = self.toDataRow('Image', imgtooltip);

          const arrayValue = [];
          arrayValue.push(addressRow);
          arrayValue.push(gps);
          arrayValue.push(time);
          arrayValue.push(speed);
          arrayValue.push(heading);

          if (self.tooltipConfig) {
            for (const key1 in self.tooltipConfig) {
              if (self.tooltipConfig.hasOwnProperty(key1)) {
                const key2 = self.tooltipConfig[key1];
                let value = self.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
                value = value ? value : '';
                const tooltipRow = self.toDataRow(key1, value);
                arrayValue.push(tooltipRow);
              }
            }
          }

          arrayValue.push(imageRow);
          const text = name + self.toHtmlTable(arrayValue);
          const infoWindow = new self.google.maps.InfoWindow({
              content: text,
              position: this.position,
              maxWidth: width
          });
          arrow.infoWindow = infoWindow;
          infoWindow.open(self.map, this);
          self.previousPopup = infoWindow;


          const location = [this.data.longitude, this.data.latitude];
          self.convertGPSToAddress(location, (data1) => {
            if (data1 == null) { return; }
            if (arrow.infoWindow) {
              const temp = {properties: {}};
              const address = self.sclUtilMapService.fillGoogleAddress(data1.data.results[0], temp);
              let text1 = (address.properties.streetNo) ? address.properties.streetNo : '';
              text1 += ' ' + ((address.properties.street) ? address.properties.street : '');
              text1 += '<br>' + ((address.properties.suburb) ? address.properties.suburb  : '');
              text1 += '<br> ' + ((address.properties.state) ? address.properties.state : '');
              text1 += ', ' + ((address.properties.country) ? address.properties.country : '');
              addressRow.col2 = text1;
              const arrayValue1 = [];
              arrayValue1.push(addressRow);
              arrayValue1.push(gps);
              arrayValue1.push(time);
              arrayValue1.push(speed);
              arrayValue1.push(heading);

              if (self.tooltipConfig) {
                for (const key1 in self.tooltipConfig) {
                  if (self.tooltipConfig.hasOwnProperty(key1)) {
                    const key2 = self.tooltipConfig[key1];
                    let value = self.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
                    value = value ? value : '';
                    const tooltipRow = self.toDataRow(key1, value);
                    arrayValue1.push(tooltipRow);
                  }
                }
              }

              arrayValue1.push(imageRow);
              text1 = name + self.toHtmlTable(arrayValue1);
              arrow.infoWindow.setContent(text1);
            }
          });

        }

        arrow.addListener('mouseout', () => {
            // if(arrow.infoWindow)
            // {
            //     arrow.infoWindow.close();
            // }
        });
        this.markers.push(arrow);
    }

    const line = new this.google.maps.Polyline({
        path: listCoordinate,
        editable: false,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        map: this.map
    });
    this.polyLines.push(line);
  }
  toDataRow(col1, col2) {
    const row: any = {};
    row.col1 = col1;
    row.col2 = col2;
    return row;
  }
  toHtmlTable(array) {
      const style = '';
      let tableText = '<table style="width:100%" class = "table-popup">';
      for (let i = 0; i < array.length; i++) {
        tableText += '<tr>';
        tableText += '<td class = "table-popup">' + array[i].col1 + '</td>';
        tableText += '<td class = "table-popup">' + array[i].col2 + '</td>';
        tableText += '</tr>';
      }
      tableText += '</table>';
      return tableText;
  }
  convertGPSToAddress(coor, cb) {
    const lat = parseFloat(coor[1]);
    const lon = parseFloat(coor[0]);

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }
  formatDateTime(time) {
    const longDate = 'MMM DD YYYY, h:mm:ss a';
    const timeReturn = moment(time).format(longDate);
    return timeReturn;
  }


  watchEndDate() {
    if (this.isfirstTimeupdateEnddate) {
      this.isfirstTimeupdateEnddate = false;
    } else {
      this.changeData();
    }
  }
  watchStartDate() {
    if (this.isfirstTimeupdateStartdate) {
      this.isfirstTimeupdateStartdate = false;
    } else {
      this.changeData();
    }
  }
  watchMaxSpeed() {
    if (this.isfirstTimeupdateMaxSpeed) {
      this.isfirstTimeupdateMaxSpeed = false;
    } else {
      this.changeData();
    }
  }
  watchMinSpeed() {
    if (this.isfirstTimeupdateMinSpeed) {
      this.isfirstTimeupdateMinSpeed = false;
    } else {
      this.changeData();
    }
  }

  watchAvlVehiclesField(value) {
    console.log('watchAvlVehiclesField, value = ' + value);
    this.vehicles = value;
    if (this.vehicles && this.vehicles.length > 0) {
      this.isFirstTime = true;
    }
    this.changeData();
  }

  watchDateTimeFieldStart(value) {
    console.log('Change start date = ' + value);
    if (!value) { value = new Date(); }
    this.startDate = value;
    this.watchStartDate();
  }

  watchDateTimeFieldEnd(value) {
    console.log('Change end date = ' + value);
    if (!value) { value = new Date(); }
    this.endDate = value;
    this.watchEndDate();
  }

  watchMaxSpeedDoc(value) {
    console.log('Change maxSpeed = ' + value);
    if (!value) { value = Number.MAX_VALUE; }
    this.maxSpeed = value;
    this.watchMaxSpeed();
  }

  watchMinSpeedDoc(value) {
    console.log('Change minSpeed = ' + value);
    if (!value) { value = 0; }
    this.minSpeed = value;
    this.watchMinSpeed();
  }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
